<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-08 11:25:15
 * @LastEditors: lwq
 * @LastEditTime: 2020-07-09 15:13:28
--> 
<template>
  <div class="translateIntelnationModule mb-5">
    <v-row @click="expand = !expand">
      <v-col class="translateType">
        <v-icon class="mx-4">expand_more</v-icon>
        <span>{{subIndex}}.{{obj.language_data_type_label}}</span>
      </v-col>
    </v-row>
    <v-expand-transition>
      <div v-show="expand">
        <label-child v-for="(item, index) in obj.mrbase_sys_language_version"
                     :key='index'
                     :obj='item' />
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import labelChild from './labelTranslate'
export default {
  components: { labelChild },
  props: {
    obj: {
      type: Object
    },
    subIndex: {
      type: Number
    }
  },
  data () {
    return {
      expand: false
    };
  },
  computed: {},
  created () { },
  watch: {},
  mounted () { },

  methods: {

  },
};
</script>

<style scoped>
.translateIntelnationModule {
  border: 1px solid #ececec;
  border-radius: 10px;
  padding: 0 3px;
}
.translateType {
  height: 48px;
  display: flex;
  align-items: center;
  font-size: 17px;
}
</style>
